import { FC } from 'react';
import { Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

export interface RideCapRequestModalProps {
  isOpen: boolean;
  handleResubmit: () => void;
  handleClose: () => void;
}

export const RideCapRequestModal: FC<RideCapRequestModalProps> = ({ isOpen, handleClose, handleResubmit }) => {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Modal.Title>Your ride request has been received</Modal.Title>
      <Modal.Content>
        <Text variant="body1" fontWeight={300}>
          Our team is now reviewing your request and will provide an update within six business hours. You can check the
          status of your request in your ride list. Please request all rides needed so we can get a comprehensive
          understanding of your needs.
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={handleClose}>
          Back
        </Button>
        <Button color="primary" variant="contained" onClick={handleResubmit}>
          Send Request
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
